import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class CategoryApiClient extends AdvancedApiClient {

    static entityType = "Category"

    constructor(token, id) {
        super();

        this.setEntityType(CategoryApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/category/{id}")
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/category");
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}